import React, {Component} from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Layout from '../_layout/index';
import MainWrapper from './MainWrapper';

import Dashboard from '../../pages/dashboard/DefaultDashboard';
import Sales from '../../pages/sales/Sales';
import Providers from '../../pages/providers/Providers';
import SalesItem from '../../pages/sales/SalesItem';
import TVSalesItem from '../../pages/sales/TVSalesItem';
import InternetSalesItem from '../../pages/sales/InternetSalesItem';
import Customers from '../../pages/customers/Customers';
import Settings from '../../pages/settings/Settings'
import ErrorPage from '../../pages/error/ErrorPage';
import Orders from '../../pages/orders/Orders'

/*const Pages = () => (
  <Switch>

  </Switch>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/pages" component={Pages} />
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route exact path="/log_in" component={LogIn} />
        <Route path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;*/

class Router extends Component {

    render() {

        let content;
        if (this.props.hasError) {
            content = wrappedRoutesError;
        }
        else {
            if (this.props.isAdmin) {
                content = wrappedAdminManager;
            }
            else {
                content = wrappedRoutes;
            }
        }

        return (
            <MainWrapper>
                <main>
                    <Switch>
                        <Redirect from="/" exact to="/dashboard"/>
                        <Route path='/' component={content}/>
                    </Switch>
                </main>
            </MainWrapper>
        );
    }
}


const wrappedRoutesError = () => (
    <div>
        <Layout/>
        <div className='container__wrap'>

            <ErrorPage/>

        </div>
    </div>
);

const wrappedRoutes = () => {
    return (
        <div>
            <Layout/>
            <div className='container__wrap'>
                <Route path='/dashboard' component={Dashboard}/>
                <Route exact path='/sales' component={Sales}/>
                <Route exact path='/sales/:id' component={SalesItem}/>
                <Route exact path='/sales/2/:id' component={SalesItem}/>
                <Route exact path='/sales/3/:id' component={SalesItem}/>
                <Route exact path='/providers' component={Providers}/>
                <Route path='/customers' component={Customers}/>
                <Route path='/orders' component={Orders}/>
            </div>
        </div>
    )
};

const wrappedAdminManager = () => {

    return (

        <div>
            <Layout/>
            <div className='container__wrap'>
                <Route path='/dashboard' component={Dashboard}/>
                <Route exact path='/sales' component={Sales}/>
                <Route exact path='/sales/:id' component={SalesItem}/>
                <Route exact path='/sales/2/:id' component={SalesItem}/>
                <Route exact path='/sales/3/:id' component={SalesItem}/>
                <Route exact path='/providers' component={Providers}/>
                <Route path='/customers' component={Customers}/>
                <Route path='/settings' component={Settings}/>
                <Route path='/orders' component={Orders}/>
            </div>
        </div>
    )
};


export default Router;

